import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, FileText, Shield } from 'lucide-react';
import { CASA_CARTARUM_LOGO } from '../data/mockMaps';

const Footer = () => {
  return (
    <footer 
      id="contact" 
      className="text-white"
      style={{
        backgroundColor: '#2C1810',
        borderTop: '1px solid #C5A059'
      }}
    >
      {/* Main Contact Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Header - Mobile centered, Desktop left-aligned */}
        <div className="flex flex-col items-center text-center md:flex-row md:items-start md:text-left gap-4 mb-12">
          <img 
            src={CASA_CARTARUM_LOGO} 
            alt="Casa Cartarum" 
            className="h-20 w-auto"
            style={{ imageRendering: 'auto', WebkitImageSmoothing: 'high' }}
          />
          <div className="w-full md:w-auto">
            <h2 
              className="text-2xl sm:text-3xl md:text-4xl font-bold"
              style={{ 
                fontFamily: "'Cinzel', serif",
                color: '#EFEBE9'
              }}
            >
              Contactează-ne
            </h2>
            <p 
              className="mt-1"
              style={{ 
                color: 'rgba(197, 160, 89, 0.8)',
                fontFamily: "'Cormorant Garamond', serif"
              }}
            >
              Asociația Culturală Dobrogenius
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Info - Mobile centered */}
          <div className="text-center md:text-left">
            <h3 
              className="text-xl sm:text-2xl font-bold mb-6"
              style={{ 
                fontFamily: "'Cinzel', serif",
                color: '#EFEBE9'
              }}
            >
              Informații de Contact
            </h3>
            
            <div className="space-y-6">
              <div 
                className="p-6 rounded-lg"
                style={{ 
                  backgroundColor: 'rgba(120, 53, 15, 0.2)',
                  border: '1px solid rgba(197, 160, 89, 0.3)'
                }}
              >
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: 'rgba(180, 83, 9, 0.3)' }}
                  >
                    <Phone style={{ color: '#C5A059' }} size={24} />
                  </div>
                  <div>
                    <h4 
                      className="text-lg font-semibold mb-1"
                      style={{ color: '#EFEBE9' }}
                    >
                      Telefon
                    </h4>
                    <p style={{ color: 'rgba(239, 235, 233, 0.8)' }}>+40 722 352 545</p>
                  </div>
                </div>
              </div>

              <div 
                className="p-6 rounded-lg"
                style={{ 
                  backgroundColor: 'rgba(120, 53, 15, 0.2)',
                  border: '1px solid rgba(197, 160, 89, 0.3)'
                }}
              >
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: 'rgba(180, 83, 9, 0.3)' }}
                  >
                    <Mail style={{ color: '#C5A059' }} size={24} />
                  </div>
                  <div>
                    <h4 
                      className="text-lg font-semibold mb-1"
                      style={{ color: '#EFEBE9' }}
                    >
                      Email
                    </h4>
                    <a 
                      href="mailto:contact@dobrogenius.ro" 
                      className="transition-colors"
                      style={{ color: '#C5A059' }}
                      data-testid="contact-email-link"
                    >
                      contact@dobrogenius.ro
                    </a>
                  </div>
                </div>
              </div>

              <div 
                className="p-6 rounded-lg"
                style={{ 
                  backgroundColor: 'rgba(120, 53, 15, 0.2)',
                  border: '1px solid rgba(197, 160, 89, 0.3)'
                }}
              >
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: 'rgba(180, 83, 9, 0.3)' }}
                  >
                    <MapPin style={{ color: '#C5A059' }} size={24} />
                  </div>
                  <div>
                    <h4 
                      className="text-lg font-semibold mb-1"
                      style={{ color: '#EFEBE9' }}
                    >
                      Locație
                    </h4>
                    <p style={{ color: 'rgba(239, 235, 233, 0.8)' }}>România</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* About - Mobile centered */}
          <div className="text-center md:text-left">
            <h3 
              className="text-xl sm:text-2xl font-bold mb-6"
              style={{ 
                fontFamily: "'Cinzel', serif",
                color: '#EFEBE9'
              }}
            >
              Despre Casa Cartarum
            </h3>
            <div 
              className="p-6 rounded-lg"
              style={{ 
                background: 'linear-gradient(to bottom right, rgba(120, 53, 15, 0.2), rgba(146, 64, 14, 0.1))',
                border: '1px solid rgba(180, 83, 9, 0.3)'
              }}
            >
              <p 
                className="leading-relaxed"
                style={{ 
                  color: 'rgba(239, 235, 233, 0.7)',
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: '1.1rem'
                }}
              >
                Suntem o platformă digitală culturală dedicată explorării și conservării patrimoniului 
                cartografic istoric dobrogean, românesc și european. Oferim acces la hărți istorice 
                digitalizate, cronici istorice, audio-ghiduri și explorare 3D interactivă.
              </p>
            </div>
          </div>
        </div>

        {/* Legal Information Section */}
        <div 
          className="mt-16 pt-12"
          style={{ borderTop: '1px solid rgba(197, 160, 89, 0.3)' }}
        >
          <div 
            className="rounded-lg p-8"
            style={{ 
              background: 'linear-gradient(to bottom right, rgba(120, 53, 15, 0.2), rgba(146, 64, 14, 0.1))',
              border: '1px solid rgba(180, 83, 9, 0.3)'
            }}
          >
            <h3 
              className="text-2xl font-semibold mb-4"
              style={{ 
                fontFamily: "'Cinzel', serif",
                color: '#EFEBE9'
              }}
            >
              Informații Legale
            </h3>
            <p 
              className="mb-6"
              style={{ color: 'rgba(239, 235, 233, 0.7)' }}
            >
              Consultați documentele noastre legale pentru mai multe detalii despre cum protejăm 
              confidențialitatea dumneavoastră și termenii de utilizare ai platformei.
            </p>
            
            <div className="flex flex-col sm:flex-row flex-wrap justify-center md:justify-start gap-4">
              <Link
                to="/termeni-conditii"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg transition-colors font-semibold"
                style={{
                  backgroundColor: '#B45309',
                  color: 'white'
                }}
                data-testid="link-terms"
              >
                <FileText size={20} />
                <span>Termeni și Condiții</span>
              </Link>
              
              <Link
                to="/politica-confidentialitate"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg transition-colors font-semibold"
                style={{
                  backgroundColor: 'rgba(146, 64, 14, 0.5)',
                  border: '1px solid #B45309',
                  color: '#EFEBE9'
                }}
                data-testid="link-privacy"
              >
                <Shield size={20} />
                <span>Politică de Confidențialitate</span>
              </Link>
            </div>

            <p 
              className="text-sm mt-6"
              style={{ color: 'rgba(239, 235, 233, 0.5)' }}
            >
              Pentru întrebări sau nelămuriri, nu ezitați să ne contactați la{' '}
              <a 
                href="mailto:contact@dobrogenius.ro" 
                className="transition-colors"
                style={{ color: '#C5A059' }}
              >
                contact@dobrogenius.ro
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div 
        className="py-8"
        style={{ 
          backgroundColor: 'rgba(26, 26, 26, 0.5)',
          borderTop: '1px solid rgba(197, 160, 89, 0.3)'
        }}
      >
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p 
            className="text-sm"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              color: 'rgba(239, 235, 233, 0.6)'
            }}
          >
            &copy; {new Date().getFullYear()} Casa Cartarum - Asociația Culturală Dobrogenius. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
